import { withInstall } from "../../utils/vue/install.mjs";
import { badgeProps } from "./src/badge.mjs";
import badge_default from "./src/badge2.mjs";

//#region ../../packages/components/badge/index.ts
const ElBadge = withInstall(badge_default);

//#endregion
export { ElBadge, ElBadge as default, badgeProps };
//# sourceMappingURL=index.mjs.map